import {ELEMENT_IDS} from "./DesktopDOM";

export default class BottomBoxComponent {

    private title: HTMLElement;
    private value: HTMLElement;
    private content: HTMLElement;

    public leftBtn: HTMLElement;
    public rightBtn: HTMLElement;

    constructor({name, el, btns= false, valueId = ""}) {

        let title = document.createElement("div");
        title.classList.add("bottom-box-title");
        title.classList.add("mx-translate");
        title.setAttribute("data-lang", name);
        this.title = title;

        el.appendChild(title);

        let content = document.createElement("div");
        content.classList.add("bottom-box-content");
        el.appendChild(content);

        if(btns) {
            content.classList.add("with-buttons");

            let leftBtn = document.createElement("button");
            leftBtn.classList.add("bottom-box-btn", "mx-bottom-box-btn-left", "mx-input", "mx-button");
            content.appendChild(leftBtn);
            this.leftBtn = leftBtn;

            let rightBtn = document.createElement("button");
            rightBtn.classList.add("bottom-box-btn", "mx-bottom-box-btn-right", "mx-input", "mx-button");
            content.appendChild(rightBtn);
            this.rightBtn = rightBtn;
        }

        let value = document.createElement("div");
        value.classList.add("bottom-box-value");
        valueId === ELEMENT_IDS.WIN && value.classList.add("bottom-box-value-win");
        value.id = valueId;
        content.appendChild(value);
    }

    public rename(name) {
        this.title.setAttribute("data-lang", name);
    }


}